var map = {
	"./baseball-background.jpg": 8639,
	"./basic-background-da.jpg": 7335,
	"./basic-background.jpg": 6975,
	"./basketball-background.jpg": 1220,
	"./football-background.jpg": 94,
	"./golf-background.jpg": 2563,
	"./hockey-background.jpg": 4622,
	"./horseracing-background.jpg": 2762,
	"./soccer-background.jpg": 3564,
	"./sport-background.jpg": 1759,
	"./tennis-background.jpg": 4672
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	var id = map[req];
	return __webpack_require__.t(id, 1 | 16);
});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7198;
module.exports = webpackAsyncContext;